import styled from '@emotion/styled';
import { themed, ITheme } from '../../themer';
import { CheckIcon } from '../Icon';

export const BaseCheckboxIcon = styled.div<{}, ITheme>`
	position: relative;
	display: inline-block;
	vertical-align: middle;
	margin-right: 12px;

	&:after {
		content: '';
		position: absolute;
		top: 50%;
		left: 50%;
		transform: translate(-50%, -50%);
	}

	svg {
		display: none;
	}
`;

export interface IStyledCheckboxProps {
	disabled?: boolean;
	invalid?: boolean;
}

const getCheckboxBorderColor = themed<IStyledCheckboxProps>(
	({ checkbox, color }, { disabled, invalid }) => {
		if (invalid) {
			return color.state.error;
		}

		return (
			(disabled ? checkbox.disabled.color : checkbox.color) ??
			color.border.default
		);
	},
);

export const StyledCheckboxIcon = styled(BaseCheckboxIcon)<
	IStyledCheckboxProps,
	ITheme
>`
	flex-shrink: 0;
	flex-grow: 0;
	margin-top: 0.1em;
	width: ${themed(({ checkbox }) => checkbox.size)};
	height: ${themed(({ checkbox }) => checkbox.size)};
	border: 2px solid ${getCheckboxBorderColor};
	border-radius: ${themed(({ checkbox }) => checkbox.borderRadius)};

	&:after {
		display: none;
		width: ${themed(({ checkbox }) => checkbox.innerSize)};
		height: ${themed(({ checkbox }) => checkbox.innerSize)};
		background: center / contain no-repeat url(${CheckIcon});
	}
`;

export const StyledCheckbox = styled.label<IStyledCheckboxProps, ITheme>`
	display: flex;
	opacity: ${themed(({ checkbox }, { disabled }) =>
		disabled ? checkbox.disabled.opacity : '',
	)};

	input:checked + ${StyledCheckboxIcon} {
		${themed(({ checkbox, color }, { disabled }) => {
			const activeColor =
				(disabled ? checkbox.disabled.active.color : checkbox.active.color) ??
				color.highlight;

			return `
			background: ${activeColor};
			border-color: ${activeColor};
		`;
		})};
		color: ${themed(({ checkbox }) => checkbox.icon.color)};

		svg {
			display: block;

			height: ${themed(({ checkbox }) => checkbox.icon.size)};
			width: ${themed(({ checkbox }) => checkbox.icon.size)};
		}

		&:after {
			display: block;
		}
	}
`;
